// @flow

/**
 * Get unique array of objects
 *
 * @param {array} array
 * @param {string} key
 *
 * @return {array}
 */
export function getUnique<T: {}>(array?: T[] = [], key: string): T[] {
  const map = new Set();

  return array.filter((item) => {
    if (map.has(item[key])) {
      return false;
    }

    map.add(item[key]);

    return true;
  });
}

export default getUnique;



// WEBPACK FOOTER //
// ./src/common/utils/getUnique.js